import { useLocalObservable } from 'mobx-react-lite';
import StoreAction from '@store/StoreAction';
import { runInAction } from 'mobx';
import {
    getQryAccountInfo,
    callGetCustomerInfo,
    getQryBankStatement,
} from '@api';

const initialState = {
    startDate: new Date(),
    endDate: new Date(),
    bankStatementDetails: [],
};

const api = {
    qryAccountInfo: getQryAccountInfo,
    getInfo: callGetCustomerInfo,
    qryBankStatement: getQryBankStatement,
};
const BankStatementStore = () =>
    useLocalObservable(() => ({
        /* observables */
        ...initialState,
        ...StoreAction(initialState),
        ...api,
        async getBankStatementDetails(defaultValue, startDate, endDate) {
            const postData = {
                queryType: defaultValue,
                startDate: startDate,
                endDate: endDate,
            };
            const res = await this.qryBankStatement(postData);
            const bankStatementDetails = res.data.item.bankStatementDetails;
            this.assignData({ bankStatementDetails });
        },
    })); // 3

export default BankStatementStore; // 2
